//
//
//
//
//
//
//
//
//
//

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Cover', component.exports)
}
export default {
	props: {
		gap: {
			type: String,
			default: '0'
		},
		height: {
			type: String,
			default: '100vh'
		}
	}
};
